// accountOptions.js
  
export const statusOptions = [
    { value: 'Open', label: 'Offen' },
    { value: 'Partially Filled', label: 'Teilweise erfüllt' },
    { value: 'Filled', label: 'Erfüllt' },
    { value: 'Rejected', label: 'Abgelehnt' },
  ];

export const accountTypeOptions = [
    { value: 'inactive', label: 'Inaktiv' },
    { value: 'prospect', label: 'Interessent' },
    { value: 'customer', label: 'Kunde' },
    { value: 'partner', label: 'Partner' },
    { value: 'competitor', label: 'Wettbewerber' },
    { value: 'supplier', label: 'Anbieter' },
    { value: 'other', label: 'Sonstiges' },
  ];

export const accountSegmentOptions = [
    { value: 'strategic', label: 'Strategisch' },
    { value: 'high_value', label: 'Hochwertig' },
    { value: 'core', label: 'Kernkunde' },
    { value: 'emerging', label: 'Wachsend' },
  ];

export const organizationTypeOptions = [
    { value: 'private_company', label: 'Privatwirtschaftliches Unternehmen' },
    { value: 'public_company', label: 'Börsennotiertes Unternehmen' },
    { value: 'government', label: 'Öffentliche Einrichtung / Behörde' },
    { value: 'non_profit', label: 'Non-Profit-Organisation' }
  ];

export const organizationSizeOptions = [
    { value: '1_to_50', label: '1–50' },
    { value: '51_to_250', label: '51–250' },
    { value: '251_to_1000', label: '251–1.000' },
    { value: '1001_to_5000', label: '1.001–5.000' },
    { value: 'over_5000', label: '5.000+' }
  ];

export const revenueRangeOptions = [
    { value: 'under_1m', label: '< 1 Mio. €' },
    { value: '1_to_10m', label: '1 – 10 Mio. €' },
    { value: '10_to_50m', label: '10 – 50 Mio. €' },
    { value: '50_to_100m', label: '50 – 100 Mio. €' },
    { value: '100_to_500m', label: '100 – 500 Mio. €' },
    { value: '500m_to_1b', label: '500 Mio. – 1 Mrd. €' },
    { value: '1b_to_5b', label: '1 – 5 Mrd. €' },
    { value: 'over_5b', label: '> 5 Mrd. €' },
  ];

export const industryOptions = [
    { value: 'automotive', label: 'Automobilindustrie' },
    { value: 'construction_real_estate', label: 'Bauwesen / Immobilien' },
    { value: 'consulting_professional_services', label: 'Beratung / Professionelle Dienstleistungen' },
    { value: 'chemistry', label: 'Chemie' },
    { value: 'education', label: 'Bildung' },
    { value: 'energy_utilities', label: 'Energie / Versorgungsunternehmen' },
    { value: 'financial_services', label: 'Finanzdienstleistungen' },
    { value: 'healthcare_life_sciences', label: 'Gesundheitswesen / Lebenswissenschaften' },
    { value: 'healthcare_pharma', label: 'Gesundheitswesen / Pharma' },
    { value: 'industrial_manufacturing', label: 'Industrie / Fertigung' },
    { value: 'insurance', label: 'Versicherungen' },
    { value: 'logistics_transportation', label: 'Logistik / Transport' },
    { value: 'media_marketing_agencies', label: 'Medien / Marketing / Agenturen' },
    { value: 'non_profit', label: 'Gemeinnützige Organisationen' },
    { value: 'other', label: 'Sonstiges' },
    { value: 'public_sector', label: 'Öffentlicher Sektor' },
    { value: 'retail_ecommerce', label: 'Einzelhandel / E-Commerce' },
    { value: 'technology_software', label: 'Technologie / Software' },
    { value: 'telecommunications', label: 'Telekommunikation' },
];

export const legalFormOptions = [
    { value: 'unknown', label: 'Unbekannt' },
    { value: 'ag', label: 'Aktiengesellschaft (AG)' },
    { value: 'authority_public_body', label: 'Behörde / Öffentlicher Träger' },
    { value: 'bv', label: 'Besloten Vennootschap (BV)' },
    { value: 'corporation_inc', label: 'Corporation (Inc.)' },
    { value: 'eg', label: 'Eingetragene Genossenschaft (eG)' },
    { value: 'ek', label: 'Eingetragener Kaufmann (e.K.)' },
    { value: 'ev', label: 'Eingetragener Verein (e.V.)' },
    { value: 'freelancer', label: 'Freiberufler' },
    { value: 'foundation', label: 'Stiftung' },
    { value: 'gbr', label: 'Gesellschaft bürgerlichen Rechts (GbR)' },
    { value: 'ggmbh', label: 'Gemeinnützige GmbH (gGmbH)' },
    { value: 'gmbh', label: 'Gesellschaft mit beschränkter Haftung (GmbH)' },
    { value: 'gmbh_co_kg', label: 'GmbH & Co. KG' },
    { value: 'kg', label: 'Kommanditgesellschaft (KG)' },
    { value: 'ltd', label: 'Limited (Ltd.)' },
    { value: 'non_profit', label: 'Non-Profit / Verein' },
    { value: 'nv', label: 'Naamloze Vennootschap (NV)' },
    { value: 'ohg', label: 'Offene Handelsgesellschaft (OHG)' },
    { value: 'partg', label: 'Partnerschaftsgesellschaft (PartG)' },
    { value: 'public_company', label: 'Public Company' },
    { value: 'sarl', label: 'Société à responsabilité limitée (SARL)' },
    { value: 'se', label: 'Societas Europaea (SE)' },
    { value: 'sole_proprietorship', label: 'Einzelunternehmen' },
    { value: 'ug', label: 'Unternehmergesellschaft (haftungsbeschränkt)' },
];